// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolSharedWithAccountBody = {
  accountId: string;
};

export type typePoolSharedWithAccountOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    pools: {
      poolId: string;
      name: string;
      sportKey: string;
      leagueKey: string;
      seasonYear: number;
      contestType: "survivor" | "squares" | "stripCard" | "pickem";
      poolStatus: "active" | "archived";
      leagueLabel: string;
      bannerImageUrl?: string | null;
      creatorHandle?: string | null;
    }[];
  };
};

export type typePoolSharedWithAccountOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolSharedWithAccountOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolSharedWithAccountOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolSharedWithAccountBody = {
  type: "object",
  properties: { accountId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["accountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolSharedWithAccount(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolSharedWithAccountBody);
  }

  return async function postPoolSharedWithAccount(
    payload: typePoolSharedWithAccountBody,
  ): Promise<
    typePoolSharedWithAccountOutput200 | typePoolSharedWithAccountOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolSharedWithAccount" failed before calling the network. #830e68acc3c6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#830e68acc3c6" },
        },
        data: null,
      } as typePoolSharedWithAccountOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/shared-with-account`,
      httpMethod: "POST",
      options,
    })) as
      typePoolSharedWithAccountOutput200 | typePoolSharedWithAccountOutput400;
  };
}
